export default __webpack_public_path__ + "static/media/site-img-1.b66f3993.webp";